<template>
  <div class="about-us">
    <custom-title zh="关于我们" en="ABOUT US" />
    <div class="content">
      <div>
        迪哲教育（控股）有限公司<span class="blue-text">
          DEGREE EDUCATION ( HOLDING ) LIMITED </span
        >注册于英属维尔京群岛 BVI，
        总部设于香港，在深圳、成都都注册有全资子公司，公司旗下业务主要是精准针对庞大的国内准留学生及海外留学生市场，
        提供“从<b>智能化 DIT 申请</b
        >到<b>目的地服务</b>再到<b>归国人才服务</b>”的一站式留学服务互联网 +
        平台， 围绕海归人才打造一个贯通整个留学产业链条的互联网 + 生态圈。
      </div>
      <img src="../assets/images/logo_blue.svg" />
    </div>
  </div>
</template>

<script>
import CustomTitle from "../components/common/CustomTitle";

export default {
  components: {
    CustomTitle
  }
};
</script>

<style lang="scss" scoped>
.about-us {
  width: 1291px;
  margin: 0 auto;
}
.content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > div {
    flex-basis: 634px;
    line-height: 1.5;
  }

  & > img {
    margin-right: 146px;
    width: 300px;
    flex-shrink: 0;
  }
}
</style>
